import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, catchError, map } from 'rxjs';
import { AuthServiceService } from './auth-service.service';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  // _liveApiUrl: any = this.authService._liveApiUrl;
    get _liveApiUrl() {
    return this.authService._liveApiUrl;
  }
  private searchText = new BehaviorSubject<any>('');

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private toastr: ToastrService,
    public authService: AuthServiceService
  ) {}

  private _company = new BehaviorSubject<object[]>([]);
  private companyData: { company: object[] } = { company: [] };

  private _orgCount = new BehaviorSubject<object[]>([]);
  private orgCountData: { orgCount: object[] } = { orgCount: [] };

  getCompany(): Observable<any[]> {
    return this._company.asObservable();
  }

  getOrgCount(): Observable<any[]> {
    return this._orgCount.asObservable();
  }
  updateSearchText(val:any){
    this.searchText.next(val)
  }
  getSearchText(){
    return this.searchText;
  }
companyaddCard(form:any){
  return this.http
  .post<any>(`${this._liveApiUrl}/tenant/organization/`, form)
  .pipe(
    map((data) => {
      return data;
    }),
    catchError(this.authService.handleError)
  );
}
updatePlanUsingCard(form:any,id:any){
  return this.http
  .put<any>(`${this._liveApiUrl}/tenant/organization-plan-change/${id}`, form)
  .pipe(
    map((data) => {
      return data;
    }),
    catchError(this.authService.handleError)
  );
}
getPlanHistory(id:any){
  return this.http
  .get<any>(`${this._liveApiUrl}/tenant/company-plan-history/?org_id=${id}`)
  .pipe(
    map((data) => {
      return data;
    }),
    catchError(this.authService.handleError)
  );
}
  companyAdd(form: any, id?:any ) {
    if(id){
      return this.http
      .put<any>(`${this._liveApiUrl}/tenant/organization/${id}/`, form)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      );
    } 
    else{
      return this.http
      .post<any>(`${this._liveApiUrl}/tenant/organization/`, form)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      );
    }
    
  }

  companyList(id?: number, filter?: any, search_text?: string, page?: number) {
    let tail = '';
  
    // Include 'id' only if it's valid and not 0
    if (id != null && id !== 0) {
      tail += id;
    }
  
    let params = new URLSearchParams();
  
    // Include filter parameters if not null or undefined
    if (filter) {
      for (let key in filter) {
        if (filter[key] != null) { // Add only non-null filter values
          params.set(key, filter[key]);
        }
      }
    }
  
    // Include search_text if not null or undefined
    if (search_text != null && search_text !== '') {
      params.set('search_text', search_text);
    }
  
    // Include page if it's defined and not null, increment by 1
    if (page != null) {
      params.set('page', (page + 1).toString());
    }
  
    // Append the query parameters to the tail if any exist
    if (params.toString()) {
      tail += `?` + params.toString();
    }
  
    this.http
      .get<any>(`${this._liveApiUrl}/tenant/organization-listing/${tail}`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      )
      .subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }
  
          this.companyData.company = data;
          this._company.next(Object.assign({}, this.companyData).company);
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
  }
  
  
  

  companyDetail(companyid: Number) {
    return this.http.get<any>(
      `${this._liveApiUrl}/tenant/organization/${companyid}/`
    );
  }
  getNotifications(companyid: Number){
    return this.http.get<any>(
      `${this._liveApiUrl}/notification/superAdmin-notif-listing/?company_id=`+companyid);
  }
  sentNotification(id:any , formdata:any){
    return this.http.post<any>(
      `${this._liveApiUrl}/notification/send-owner-notification/?company_id=`+id, formdata)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      );
  }

  companyDelete(id:any) {
    return this.http.put<any>(
      `${this._liveApiUrl}/tenant/organization/delete/?org_id=`+id, {}
    );
  }

  companyActivateDeactivate(id: Number, formData:any) {
    return this.http
      .patch<any>(`${this._liveApiUrl}/tenant/organization/${id}/`,formData)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      );
  }

  orgCount() {
    this.http
      .get<any>(`${this._liveApiUrl}/tenant/org-count/`)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      )
      .subscribe(
        (data: any) => {
          if (this.authService.resultCodeError(data)) {
            return;
          }

          this.orgCountData.orgCount = data;
          this._orgCount.next(Object.assign({}, this.orgCountData).orgCount);
        },
        (error) => {
          this.authService.dataError(error);
        }
      );
  }

  companyBookmark(id: Number , formData:any) {
    return this.http
      .put<any>(`${this._liveApiUrl}/tenant/bookmark/${id}`, formData)
      .pipe(
        map((data) => {
          return data;
        }),
        catchError(this.authService.handleError)
      );
  }
}
